import { AppDataState } from './app-data-store';
import { NotificationSettings } from './interface/notification-settings';

export const SET_NOTIFICATION_SETTINGS = 'SET_NOTIFICATION_SETTINGS';

export type SetGetNotificationSettingsAction = {
  type: typeof SET_NOTIFICATION_SETTINGS;
  payload: NotificationSettings;
};

// redux update store action
export const setGetNotificationSettingsAction = (
  payload: NotificationSettings
): SetGetNotificationSettingsAction => {
  return {
    type: SET_NOTIFICATION_SETTINGS,
    payload,
  };
};

// redux reducer handler - state updater
export const setGetNotificationSettingsHandler = (
  state: AppDataState,
  action: SetGetNotificationSettingsAction
): AppDataState => {
  return {
    ...state,
    notificationSettings: action.payload,
  };
};
